import { render, staticRenderFns } from "./FarmerProductionList.vue?vue&type=template&id=3fd670e4"
import script from "./FarmerProductionList.vue?vue&type=script&lang=js"
export * from "./FarmerProductionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports